import {ApiParamConfig} from '../../shared/models/api-param-config';
import {BusinessParamName} from '../../shared/models/request-offer/request-offer.enum';

export const API_PARAMS_CONFIG: ApiParamConfig[] = [
    {
        paramName: BusinessParamName.SESSION_ID,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.SESSION_SIMPLE_ID,
        saveFromSession: true,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.SESSION_STAGE,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.SESSION_RECREATE_ID,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.CALCULATION_ID,
        saveFromSession: true,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.STORAGE_CALCULATION_DATA_IN_PORTAL,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.OFFER_ID,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.CONFIGURATION_CODE,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.SALES_CHANNEL,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.CACHE_OFFER,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.MAIL_NOTIFICATION,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.RECALCULATION_OFFER,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.ORDER_ID,
        saveFromSession: true,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.INSURANCE_COMPANY_CODE,
        saveFromSession: true,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.CALCULATION_SIMPLE_ID,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.REFERENCE_OFFER_ID,
        saveFromSession: true,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.PARTNER_SHORT_NAME,
        saveFromSession: true,
        saveInRecreatedSession: true
    },
    {
        paramName: BusinessParamName.CALCULATION_SOURCE,
        saveFromSession: true,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.CLIENT_SOURCE,
        saveFromSession: false,
        saveInRecreatedSession: true
    },
    {
        paramName: BusinessParamName.APPLICATION_ID,
        saveFromSession: true,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.CHANGED_OFFER,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.SELECTED_USER_FILTERS,
        saveFromSession: true,
        saveInRecreatedSession: true
    },
    {
        paramName: BusinessParamName.PARTNER_CALCULATION_ID,
        saveFromSession: true,
        saveInRecreatedSession: true
    },
    {
        paramName: BusinessParamName.LOGGED_USER_ID,
        saveFromSession: true,
        saveInRecreatedSession: true
    },
    {
        paramName: BusinessParamName.LAST_2_YEARS_OC_DAMAGES,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.LAST_5_YEARS_OC_DAMAGES,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.ORIGIN,
        saveFromSession: false,
        saveInRecreatedSession: true
    },
    {
        paramName: BusinessParamName.PARTNER_EXTERNAL_ID,
        saveFromSession: true,
        saveInRecreatedSession: true
    },
    {
        paramName: BusinessParamName.QUOTATION_ID,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.CONTEXT,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.ANALYTICS_USER_ID,
        saveFromSession: true,
        saveInRecreatedSession: true
    },
    {
        paramName: BusinessParamName.ANALYTICS_CLIENT_ID,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.ANALYTICS_SESSION_ID,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.OFFER_PACKAGE_NAME,
        saveFromSession: true,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.APPLICATION_CONTEXT,
        saveFromSession: true,
        saveInRecreatedSession: true
    },
    {
        paramName: BusinessParamName.PORTAL_PARTNER_ID,
        saveFromSession: true,
        saveInRecreatedSession: true
    },
    {
        paramName: BusinessParamName.PORTAL_USER_ID,
        saveFromSession: true,
        saveInRecreatedSession: true
    },
    {
        paramName: BusinessParamName.DEVICE_SERIAL_NUMBER,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.OFFER_PRIMARY_COVERAGES,
        saveFromSession: false,
        saveInRecreatedSession: false
    },
    {
        paramName: BusinessParamName.INVALID_PARTNER_NAME,
        saveFromSession: true,
        saveInRecreatedSession: true
    }
];
